import { rem } from 'polished'
import styled from 'styled-components'

import { TimelineEventStyled } from './TimelineEventStyled'
import { type ITimelineProps } from '../Timeline'

export const TimelineStyled = styled.div<Partial<ITimelineProps>>`
  font-size: ${rem(16)};

  overflow: hidden;

  ${TimelineEventStyled} {
    .gradient-line {
      visibility: visible;
    }
    .solid-line {
      visibility: hidden;
    }
  }
`
